import { useState } from 'react';
import axios from 'axios';

function ImportCSV({ onImported }) {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('');

  const handleUpload = async () => {
    if (!file) return;
    setStatus('Importing...');
    const formData = new FormData();
    formData.append('csv', file);
    try {
      const res = await axios.post('/api/import/csv', formData);
      const { imported, skipped } = res.data;
      setStatus(`✓ Imported ${imported} transactions${skipped > 0 ? ` · ${skipped} duplicates skipped` : ''}`);
      onImported();
    } catch (err) {
      setStatus('Error: ' + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="import-wrap">
      <div className="form-title">Import CSV</div>
      <div className="import-zone">
        <input type="file" accept=".csv" onChange={e => setFile(e.target.files[0])} />
        {file && <div className="import-filename">{file.name}</div>}
        <p>Export your bank statement as CSV and upload here</p>
      </div>
      <button className="btn-primary" onClick={handleUpload} disabled={!file}>Import</button>
      {status && <div className="status-msg">{status}</div>}
    </div>
  );
}

export default ImportCSV;